import React, { useState } from 'react';
import { ChevronDown, Lock } from 'lucide-react';

export default function AddPaymentMethod() {
  const [paymentType, setPaymentType] = useState('immediate');
  const [formData, setFormData] = useState({
    email: 'asankaulux.com@gmail.com',
    address: '1234 Test Dr, Clearwater, FL',
    city: 'Clearwater',
    state: 'NT',
    zip: '10000',
    country: 'United States',
    cardNumber: '',
    expiryMonth: '',
    expiryYear: ''
  });

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-lg shadow-lg overflow-hidden">
        {/* Header */}
        <div className="p-6 pb-4">
          <div className="flex items-center justify-between mb-6">
            <h1 className="text-2xl font-bold text-blue-600">Hellocer</h1>
            <button className="text-gray-400 hover:text-gray-600">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          <h2 className="text-2xl font-bold text-gray-800 mb-8">
            Set your<br />
            payment method
          </h2>

          {/* Payment Type Toggle */}
          <div className="mb-6">
            <div className="flex bg-gray-100 rounded-lg p-1">
              <button
                onClick={() => setPaymentType('immediate')}
                className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
                  paymentType === 'immediate'
                    ? 'bg-white text-gray-800 shadow-sm'
                    : 'text-gray-600 hover:text-gray-800'
                }`}
              >
                Link your card
                <div className="text-xs text-gray-500 mt-1">Charged immediately</div>
              </button>
              <button
                onClick={() => setPaymentType('monthly')}
                className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
                  paymentType === 'monthly'
                    ? 'bg-white text-gray-800 shadow-sm'
                    : 'text-gray-600 hover:text-gray-800'
                }`}
              >
                See plans
                <div className="text-xs text-gray-500 mt-1">Billed monthly</div>
              </button>
            </div>
          </div>
        </div>

        {/* Form */}
        <div className="px-6 pb-6">
          {/* Billing Information */}
          <div className="mb-6">
            <h3 className="text-sm font-semibold text-gray-700 mb-4">Billing information</h3>
            
            <div className="space-y-4">
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Email</span>
                <span className="text-sm text-gray-800">{formData.email}</span>
              </div>
              
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Address</span>
                <span className="text-sm text-gray-800">{formData.address}</span>
              </div>
              
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">City</span>
                <span className="text-sm text-gray-800">{formData.city}</span>
              </div>
              
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">State</span>
                <div className="flex items-center">
                  <span className="text-sm text-gray-800 mr-2">{formData.state}</span>
                  <ChevronDown className="w-4 h-4 text-gray-400" />
                </div>
              </div>
              
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">ZIP</span>
                <span className="text-sm text-gray-800">{formData.zip}</span>
              </div>
              
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Country</span>
                <div className="flex items-center">
                  <span className="text-xs mr-2">🇺🇸</span>
                  <span className="text-sm text-gray-800 mr-2">{formData.country}</span>
                  <ChevronDown className="w-4 h-4 text-gray-400" />
                </div>
              </div>
            </div>
          </div>

          {/* Payment Information */}
          <div className="mb-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-sm font-semibold text-gray-700">Payment information</h3>
              <div className="flex items-center text-xs text-gray-500">
                <Lock className="w-3 h-3 mr-1" />
                Secured by Stripe
              </div>
            </div>
            
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Card</label>
                <div className="flex space-x-2">
                  <div className="flex-1">
                    <input
                      type="text"
                      placeholder="Card number"
                      value={formData.cardNumber}
                      onChange={(e) => handleInputChange('cardNumber', e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                  </div>
                  <div className="flex space-x-1">
                    <input
                      type="text"
                      placeholder="MM"
                      value={formData.expiryMonth}
                      onChange={(e) => handleInputChange('expiryMonth', e.target.value)}
                      className="w-12 px-2 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-center"
                      maxLength="2"
                    />
                    <span className="flex items-center text-gray-400">/</span>
                    <input
                      type="text"
                      placeholder="YY"
                      value={formData.expiryYear}
                      onChange={(e) => handleInputChange('expiryYear', e.target.value)}
                      className="w-12 px-2 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-center"
                      maxLength="2"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="mb-6">
            <p className="text-xs text-gray-500 leading-relaxed">
              Please be informed that a token of $0.25 will be charged on your card to confirm 
              your payment method. Kindly note that this money will be automatically refunded to 
              you. Thanks
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex space-x-3">
            <button className="flex-1 py-3 px-4 border border-gray-300 rounded-md text-gray-700 font-medium hover:bg-gray-50 transition-colors">
              Cancel
            </button>
            <button className="text-sm text-gray-500 px-4">
              Terms
            </button>
            <button className="flex-1 py-3 px-4 bg-green-500 text-white rounded-md font-medium hover:bg-green-600 transition-colors">
              Pay now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}